export enum RemissionStateEnums {
  open = 1,
  finalClose = 2,
  annulled = 3,
  printed = 4,
  initialClose = 5,
  transit = 6,
  adjustments = 7,


  //Estado remision de orden

  // pendiente = 1

}